(function () {
	angular
		.module('trackeye')
		.controller('FlexEventController', FlexEventController);

	FlexEventController.$inject = ["AccountService", "ModalService", "DeviceService", "FlexEventService", "FlexEvent", "NotificationService", "LanguageService", "C4ApiService"];

	function FlexEventController(AccountService, ModalService, DeviceService, FlexEventService, FlexEvent, NotificationService, LanguageService, api) {
		var account = AccountService.get()
		var vm = this;

		vm.deviceEventTypes = [];
		vm.serverEventTypes = [];

		vm.showAdvanced = false;
		vm.is_loading = false;
		vm.isAllToggleChecked = false;

		vm.eventForm = {};

		vm.copyEventList = [];

		vm.device = DeviceService.getSelectedDevice(function(device) {
			vm.device = device;
			vm.events = FlexEventService.getEvents();
			vm.grouped = FlexEventService.getGroupedEvents();

			vm.deviceEventTypes = FlexEventService.getDeviceEventTypes();
			vm.serverEventTypes = FlexEventService.getServerEventTypes();

			vm.no_devices = DeviceService.getSutDevices().length;

			vm.is_loading = false;
		});

		var addAlarmModal = ModalService.create('add-alarm', vm),
			copyAlarmModal = ModalService.create('copy-alarm', vm),
			xhrProgressModal = ModalService.create('xhr-progress', vm);

		vm.xhrmodal = {
			title: "STR_XHRMODAL_UPDATING",
			subtitle: "STR_XHRMODAL_CREATING_ALARMS",
			progress: {
				text: "",
				max: 100,
				value: 0
			}
		};

		vm.openEventModal = function(event_id) {
			addAlarmModal.open();
			addAlarmModal.scope.event = vm.getInstance(event_id);
		};

		vm.openCopyEventModal = function (clickEvt, event) {
			clickEvt.stopPropagation();
			copyAlarmModal.open();
			copyAlarmModal.scope.event = FlexEventService.cloneEvent(event);
			copyAlarmModal.scope.devices = vm.getDevicesCompatibleWithEvent(event);
		};

		vm.showAddEventButton = function () {
			return !vm.device.isReadonly() && DeviceService.hasSutDevices();
		};

		vm.hideEventSetup = function () {
			return vm.device.features.isCapture() || !DeviceService.hasSutDevices();
		};

		vm.eventSetupHiddenMessage = function () {
			if (!DeviceService.hasSutDevices()) {
				return "STR_NO_DEVICES";
			} else if (vm.device.features.isCapture()) {
				return "STR_CHANGING_ALARMS_IS_DISABLED";
			}
		};

		/**
		 * @param {FlexEvent} event
		 * @param {string} day
		 */
		vm.toggleEventWeekday = function(event, day) {
			vm.eventForm.$setDirty(true);
			event.toggleWeekday(day);
		};

		/**
		 * @param {FlexEvent} event
		 */
		vm.toggleEventActive = function(event) {
			vm.eventForm.$setDirty(true);
			event.active = !event.active;
		};

		vm.editEvent = function(clickEvt, event_id) {
			clickEvt.stopPropagation();
			vm.openEventModal(event_id);
		};

		vm.applang = LanguageService.getAppLocaleString();
		/**
		 *
		 * @param {FlexEvent} event
		 */
		vm.saveAlarm = function (event) {
			if (!event.device.getUuid())
				event.device = vm.device;

			// event.updateLocalDate()

			vm.eventForm.$setValidity('recipients', event.hasRecipients());
			vm.eventForm.$setValidity('period', event.isPeriodValid());
			vm.eventForm.$setValidity('temperature',
				event.getEventType() === 81 ? event.hasTemperatures() : true
			);
			vm.eventForm.$setValidity('moved_distance',
				event.getEventType() === 94 ? event.hasMovedDistance() : true
			);

			if (!vm.device.hasOwner()) {
				// Only set the locale of the eventhandler, if user does not own the device.
				event.locale = LanguageService.getAppLocaleString();
			}

			if (vm.eventForm.$invalid)
				return;

			// If the eventtype is dependent on the sonic sensor,
			// set the measure_port to 1.
			if ([103, 104].indexOf(event.getEventType()) >= 0) {
				event.measure_port = 1;
			}

			event.c4api_id = account.getId()

			var defer = undefined;

			vm.is_loading = true;

			// return event.toBody();
			if (event.hasUuid()) {
				defer = FlexEventService.updateEvent(event);
			} else {
				defer = FlexEventService.createEvent(event);
			}

			defer.then(function () {
				if (event.hasUuid()) {
					NotificationService.info('STR_NOTICE_ALARM_UPDATED')
				} else {
					NotificationService.info('STR_NOTICE_ALARM_CREATED')
				}
			}).catch(function (resp) {
				//@todo forward error to backend
				console.warn(resp);
				NotificationService.warning('STR_ERROR_NOTICE_SERVER')
			}).finally(function () {
				vm.is_loading = false;
				addAlarmModal.close();
			});
		};

		vm.copyToggleDevice = function (device, deviceTotalCount) {
			var idx = vm.copyEventList.indexOf(device);

			if (idx >= 0) {
				vm.copyEventList.splice(idx, 1);
			} else {
				vm.copyEventList.push(device);
			}
			vm.isAllToggleChecked = deviceTotalCount === vm.copyEventList.length;
		};

		vm.copyToggleAllDevices = function (devices) {
			if (vm.isAllToggleChecked) {
				for (let i = 0; i < devices.length; i++) {
					const device = devices[i];
					vm.copyEventList.push(device);
				}
			} else {
				vm.copyEventList = [];
			}
		}

		vm.copyEvent = function (event) {
			copyAlarmModal.close();
			xhrProgressModal.open();
			vm.xhrmodal.progress.max = vm.copyEventList.length;

			FlexEventService.batchCreateEvent(vm.copyEventList, event, function() {
				vm.xhrmodal.progress.value++;
			}).finally(function() {
				setTimeout(function () {
					vm.xhrmodal.progress.value = 0;
					xhrProgressModal.close();
				}, 750);
			});
		};

		/**
		 *
		 * @param {FlexEvent} event
		 */
		vm.deleteAlarm = function (event) {
			vm.is_loading = true;

			FlexEventService.deleteEvent(event, vm.device).finally(function () {
				vm.is_loading = false;
				addAlarmModal.close();

				api.LogINFO("eventhandler: deleted "+event.getUuid(), true);
			});
		};

		/**
		 * Get both device and server event types, with applied limitations.
		 * @param {Device} [device]
		 * @return {Array}
		 */
		vm.getAllEventTypes = function (device) {
			if (!device)
				device = vm.device;

			var events = vm.getDeviceEventTypes(device).concat(vm.getServerEventTypes(device)),
			  	types = events.map(function (event) {
					return event.type;
				});

			types = device.limitation.filterEvents(types);

			return events.filter(function (event) {
				return (types.indexOf(event.type) >= 0);
			});
		};

		/**
		 * Get events supported by the device
		 * @param {Device} device
		 * @return {Array}
		 */
		vm.getDeviceEventTypes = function (device) {
			return vm.deviceEventTypes.filter(function (evt) {
				return evt && device.features.isFeatureBitSet(evt.feature);
			});
		};

		/**
		 * Get server events
		 * @param {Device} device
		 * @return {Array}
		 */
		vm.getServerEventTypes = function (device) {
			return vm.serverEventTypes.filter(function (event) {
				if ([97, 98].indexOf(event.type) >= 0) {
					// Events the requires the device to be prepaid
					return device.isPrepaid();
				}

				return true;
			});
		};

		/**
		 * Return a flexevent instance
		 * @param {string} [event_id]
		 * @return {FlexEvent}
		 */
		vm.getInstance = function (event_id) {
			var evt = FlexEventService.getEventByUuid(event_id);

			if (!evt) {
				return new FlexEvent({
					active: true
				}, vm.device);
			}

			vm.showAdvanced = evt.hasAdvancedSettings();
			return evt;
		};

		/**
		 * Returns a list of devices, that's compatible with
		 * the supplied FlexEvent.
		 * @param {FlexEvent} event
		 */
		vm.getDevicesCompatibleWithEvent = function (event) {
			var devices = DeviceService.getSutDevices();

			return devices.filter(function(device) {
				// Sort out the device, we're copying from.
				if (device.getUuid() === vm.device.getUuid())
					return false;

				// Exclude devices, that has not been paid for.
				if (device.isExpired())
					return false;

				var events = vm.getAllEventTypes(device);
				var found = events.find(function(evt) {
						// sort out devices, that does not have the supplied event.
						if (event.getEventType() === evt.type) {
							return true;
						}
						return false;
					});

				return !!found;
			});
		};

		/**
		 * @param {FlexEvent} event
		 * @return {Array}
		 */
		vm.weekdaysAsString = function (event) {
			var weekdays_bitmask = event.getWeekdays();

			if (!weekdays_bitmask || weekdays_bitmask == 127)
				return ['STR_ALL_DAYS'];

			var weekdays_bits = {
				"STR_MONDAY": 0,
				"STR_TUESDAY": 1,
				"STR_WEDNESDAY": 2,
				"STR_THURSDAY": 3,
				"STR_FRIDAY": 4,
				"STR_SATURDAY": 5,
				"STR_SUNDAY": 6
			};

			var weekdays_string = [];

			for (var idx in weekdays_bits) {
				if (weekdays_bits.hasOwnProperty(idx)) {
					if (event.isWeekdaySet(weekdays_bits[idx])) {
						weekdays_string.push(idx);
					}
				}
			}

			return weekdays_string;
		};
	}
})();